module.exports = ":host ::ng-deep .quote-block content .row {\n  background-color: #310b17; }\n  :host ::ng-deep .quote-block content .row .pointer::after {\n    color: #310b17; }\n\n:host ::ng-deep .related-row .container {\n  margin-bottom: 28px; }\n\n:host ::ng-deep .template-fields li:first-child,\n:host ::ng-deep .template-fields li:nth-child(n+10) {\n  display: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/containers/profile-container/profile-container.style.scss
// module id = 865
// module chunks = 2